<template>
  <div class="d-flex align-end">
      <month-picker input-class="flex-grow-0 mr-4" v-model="exportMonth"/>
      <v-tooltip bottom :disabled="!showMaxStundenTooltip">
        <template v-slot:activator="{ on, attrs }">
          <v-btn outlined
                 :loading="loading"
                 @click="exportData"
                 v-on="on"
                 v-bind="attrs"
          >
            <v-icon>mdi-cog</v-icon>
            Export
          </v-btn>
        </template>
        <div>
          <div>Achtung!</div>
          <div>Für eine oder mehrere Lohnarten wurde eine Beschränkung der Stundenanzahl pro Woche aktiviert.</div>
          <div>Daher wird bei Monatsbeginn eine angefangene Woche mit den Daten des Vormonats exportiert.</div>
        </div>
      </v-tooltip>
  </div>
</template>

<script>

import download from 'downloadjs';
import moment from 'moment';
import timeparkApi from '../../timeparkApi';
import MonthPicker from "@/components/common/MonthPicker";

export default {
  name: 'UserTimesExport',
  components: {MonthPicker},
  props: {
    showMaxStundenTooltip: Boolean
  },
  methods: {
    async exportData() {
      this.loading = true;

      try {
        const apiResponse = await timeparkApi.downloadUserTimesExport(this.exportMonth);

        download(
          apiResponse.data,
          `Export_${moment().format('DD_MM_YYYY_mm_ss')}.txt`,
          apiResponse.headers['content-type']);

      } catch (err) {
        window.console.log(err);
      }

      this.loading = false;
    },
  },
  data() {
    return {
      exportMonth: {
        month: moment().month() + 1,
        year: moment().year(),
      },
      loading: false,
    };
  },
};
</script>
